import React from "react";

import { useIntl } from "react-intl";
import { useTheme } from "styled-components";

import Illustration from "Vendor_resources/images/empty-activities.svg";
import IllustrationDark from "Vendor_resources/images/empty-activities_dark.svg";

import * as S from "./ActivityEmpty.styles";

const ActivityEmpty = ({
  activityType
}: {
  activityType: "all" | "pending" | "running" | "staged";
}) => {
  const intl = useIntl();
  const theme = useTheme();

  if (!activityType || activityType === "all") {
    return (
      <S.AllEmpty>
        <S.ImageWrapper>
          <img
            src={theme.name === "dark" ? IllustrationDark : Illustration}
            alt={intl.formatMessage({ id: "voucher.empty.title" })}
            id="empty-activities"
          />
        </S.ImageWrapper>
        {intl.formatMessage({
          id: "activities.empty.all",
          defaultMessage: "You have no recent activities"
        })}
      </S.AllEmpty>
    );
  }

  return (
    <S.CategoryEmpty className="empty-text">
      {intl.formatMessage({
        id: `activities.empty.${activityType}`,
        defaultMessage: `You have no ${activityType} activities`
      })}
    </S.CategoryEmpty>
  );
};

export default ActivityEmpty;
